import {
	sqBarStripeClass,
	sqLinearGradientClass,
	sqSolidFillClass,
	sqTextFillClass,
} from "./sq-color-visual-classes";
import { sqColorPair, sqColorStop } from "./sq-colors";

export { sqColorPair, sqColorStop };
export {
	sqBarStripeClass,
	sqLinearGradientClass,
	sqSolidFillClass,
	sqTextFillClass,
};

export const SQ_GREY_STATIC_FROM = sqColorStop("grey", "static", "from");
export const SQ_GREY_STATIC_TO = sqColorStop("grey", "static", "to");
export const SQ_GREEN_PAIR = sqColorPair("green", "static");
export const SQ_AMBER_PAIR = sqColorPair("amber", "static");
export const SQ_PURPLE_PAIR = sqColorPair("purple", "static");
export const SQ_BLUE_PAIR = sqColorPair("blue", "static");
/** Deep solids for borders / strokes (victory green, defeat red, etc.). */
export const SQ_RED_DEEP = sqColorStop("red", "deep", "from");
export const SQ_GREEN_DEEP = sqColorStop("green", "deep", "from");

export const SQ_GREY_FILL_CLASS = sqSolidFillClass("grey");
export const SQ_GREY_TEXT_CLASS = sqTextFillClass("grey", "from");
export const SQ_GREEN_TEXT_CLASS = sqTextFillClass("green", "from");
export const SQ_AMBER_TEXT_CLASS = sqTextFillClass("amber", "from");
export const SQ_GREEN_BAR_STRIPE_CLASS = sqBarStripeClass("green");
export const SQ_PURPLE_BAR_STRIPE_CLASS = sqBarStripeClass("purple");
export const SQ_AMBER_LINEAR_GRADIENT_CLASS = sqLinearGradientClass(
	"amber",
	"static",
	"135deg",
);
export const SQ_GREEN_LINEAR_GRADIENT_CLASS = sqLinearGradientClass(
	"green",
	"static",
	"135deg",
);
export const SQ_PURPLE_LINEAR_GRADIENT_CLASS = sqLinearGradientClass(
	"purple",
	"static",
	"135deg",
);
export const SQ_SLATE_PAIR = sqColorPair("slate", "static");
export const SQ_SLATE_LINEAR_GRADIENT_CLASS = sqLinearGradientClass(
	"slate",
	"static",
	"135deg",
);

/**
 * Primary CTA vertical amber gradient — literal utilities so Tailwind emits them.
 */
export const SQ_PRIMARY_CTA_GRADIENT_CLASS =
	"bg-gradient-to-b from-[var(--sq-amber-static-from)] to-[var(--sq-amber-static-to)]";
export const SQ_PRIMARY_CTA_GRADIENT_HOVER_CLASS =
	"hover:from-[#FFD053] hover:to-[#E2A11A]";
export const SQ_PRIMARY_CTA_GRADIENT_ACTIVE_CLASS =
	"active:from-[#E9B014] active:to-[#C98900]";

/** Boost meter percent badge gradients (bronze / silver / gold). */
export const SQ_BOOST_BADGE_GRADIENT_BRONZE_CLASS =
	"from-[var(--sq-bronze-static-from)] to-[var(--sq-bronze-static-to)]";
export const SQ_BOOST_BADGE_GRADIENT_SILVER_CLASS =
	"from-[var(--sq-silver-static-from)] to-[var(--sq-silver-static-to)]";
export const SQ_BOOST_BADGE_GRADIENT_GOLD_CLASS =
	"from-[var(--sq-gold-static-from)] to-[var(--sq-gold-static-to)]";
